module.exports = __webpack_public_path__ + "img/basketball_bg.8169a253.png";